<div class="technician_body">

  <div class="top_panel">
    <h2 mat-dialog-title>Technician Coverage Area</h2>
    <span (click)="close()" class="close">
        <img src="https://cdn.elitehw.com/images/cross.webp" />
    </span>
  </div>
  
  <mat-dialog-content class="mat-typography">
    <div class="body_cont">
      <form [formGroup]="technicianCoverageForm">
        <div class="input_prt">
          <h3>
            Personal Information
          </h3>
          <div class="adress_area">
            <mat-form-field appearance="outline" style="width: 72%;">
              <mat-label>Address</mat-label>
              <input
                matInput
                placeholder="Address"
                formControlName="streetAddress"
                #address
              />
              <mat-error
                *ngIf="
                  technicianCoverageForm.controls['streetAddress'].touched &&
                  technicianCoverageForm.controls['streetAddress'].hasError(
                    'required'
                  )
                "
              >
                This is a required field.</mat-error
              >
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 26%;">
              <mat-label>Unit Number</mat-label>
              <input
                matInput
                placeholder="Unit Number"
                formControlName="unitNumber"
              />
              <mat-error
                *ngIf="
                  technicianCoverageForm.controls['unitNumber'].touched &&
                  technicianCoverageForm.controls['unitNumber'].hasError('required')
                "
              >
                This is a required field.</mat-error
              >
            </mat-form-field>
          </div>
          <mat-form-field appearance="outline" fxFlex="auto">
            <mat-label>Zip Code</mat-label>
            <input matInput placeholder="Zip Code" formControlName="zip" mask="00000" (keyup)="chackZipCode()" />
            <mat-error
              *ngIf="
                technicianCoverageForm.controls['zip'].touched &&
                technicianCoverageForm.controls['zip'].hasError('required')
              "
            >
              This is a required field.</mat-error>
              <mat-error
              *ngIf="
                technicianCoverageForm.controls['zip'].touched &&
                technicianCoverageForm.controls['zip'].hasError('notValid')
              "
            >
              Please enter valid zip.</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" fxFlex="auto">
            <mat-label>City</mat-label>
            <input matInput placeholder="City" formControlName="city" />
            <mat-error
              *ngIf="
                technicianCoverageForm.controls['city'].touched &&
                technicianCoverageForm.controls['city'].hasError('required')
              "
            >
              This is a required field.</mat-error
            >
          </mat-form-field>
          <mat-form-field appearance="outline" fxFlex="auto">
              <mat-label>State</mat-label>
              <input matInput placeholder="State" formControlName="state" />
              <mat-error
                *ngIf="
                  technicianCoverageForm.controls['state'].touched &&
                  technicianCoverageForm.controls['state'].hasError('required')
                "
              >
                This is a required field.</mat-error
              >
            </mat-form-field>
        </div>
        <h3>
          Coverage area details
        </h3>
        <div>
          <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>States</mat-label>
              <mat-select multiple formControlName="states">
                <mat-option *ngFor="let state of states" [value]="state?.stateId">{{state?.title}}</mat-option>
              </mat-select>
              <mat-error
              *ngIf="
                technicianCoverageForm.controls['states'].touched &&
                technicianCoverageForm.controls['states'].hasError('required')
              "
            >
              This is a required field.</mat-error>
          </mat-form-field>
        </div>
        <div>
          <div formArrayName="zipCodes" class="zipaddprt">
            <div *ngFor="let item of zipCodes.controls; let i = index" class="zip_panel">
              <div class="answerprt">
                <mat-form-field appearance="outline">
                  <mat-label>Zip Code</mat-label>
                  <input
                    matInput
                    placeholder="Enter Zip Code"
                    formControlName="{{ i }}"
                    mask="00000"
                  />
                  <mat-error *ngIf="item.hasError('required')">
                    This is a required field.
                  </mat-error>
                  <mat-error *ngIf="item.hasError('mask')">
                      Please enter valid zip.
                    </mat-error>
                </mat-form-field>
                <span
                  (click)="removeField(i)"
                  class="remove"
                  *ngIf="zipCodes.controls.length > 1"
                  ><mat-icon>clear</mat-icon></span
                >
              </div>
            </div>
            <div class="btnprt">
              <button
              type="button"
              mat-flat-button
              (click)="addField()"
              [disabled]="
                technicianCoverageForm?.controls?.zipCodes?.status === 'INVALID'
              " class="addzip"
            >
              <mat-icon>add_circle_outline</mat-icon> Add New Zip Code
            </button>
            </div>
           
          </div>
        </div>
      </form>
    </div>
    
  </mat-dialog-content>
   <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
      <button mat-button type="button" class="sub-button" cdkFocusInitial (click)="updateTechnicianCoverage()"><span>Update</span></button>
      <button mat-button type="button" class="can-button" (click)="close()"><span>Cancel</span></button>
    </div>

</div>
